import React, { useState, useEffect } from "react";

import OffersList from "./components/memberOffers/offers-list"
import UpdateOffer from "./components/memberOffers/offers-update"
import CreateOffer from "./components/memberOffers/offers-create"


const ProfileView = () => {

  const [updateOrCreate, setUpdateOrCreate] = useState("n");
  const [id, setId] = useState();
  console.log(id)
  console.log(updateOrCreate)


  
  return (
    <>
      {updateOrCreate === "n" && <OffersList setId={(val) => setId(val)} setUpdateOrCreate={(val) => setUpdateOrCreate(val)} />}
      {updateOrCreate === "u" && <UpdateOffer id={id} setId={(val) => setId(val)} setUpdateOrCreate={(val) => setUpdateOrCreate(val)} />}
      {updateOrCreate === "c" && <CreateOffer setId={(val) => setId(val)} setUpdateOrCreate={(val) => setUpdateOrCreate(val)} />}
      
    </>
  );
};

export default ProfileView;
